import { IconButton } from "@mui/material";
import { GRID_DETAIL_PANEL_TOGGLE_COL_DEF, GridColDef } from "@mui/x-data-grid-premium";
import { TbChevronDown, TbChevronUp } from "react-icons/tb";

import {
    useClinicArrivalTasksGridActions,
    useClinicArrivalTasksGridExpandedRows,
} from "@/stores/use-clinic-arrival-tasks-grid";

import { HotelClinicTaskResolved } from "../../types";

function TasksTableDetailPanelColumn({
    rows,
}: {
    rows: HotelClinicTaskResolved[];
}): GridColDef<HotelClinicTaskResolved> {
    return {
        ...GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
        renderHeader: () => {
            const expandedRows = useClinicArrivalTasksGridExpandedRows();
            const { handleExpandAll } = useClinicArrivalTasksGridActions();

            return (
                <div className="w-full grid place-items-center">
                    <IconButton onClick={() => handleExpandAll(rows)}>
                        {expandedRows.length && expandedRows.length === rows.length ? (
                            <TbChevronUp size={18} />
                        ) : (
                            <TbChevronDown size={18} />
                        )}
                    </IconButton>
                </div>
            );
        },
    };
}

export default TasksTableDetailPanelColumn;
